import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiInstagram, FiLinkedin, FiYoutube } = FiIcons;

const Footer = () => {
  // Optimized logo
  const logoUrl = "https://res.cloudinary.com/digw3ykex/image/upload/f_auto,q_auto/v1767262722/LIVING_MEDIA_LOGO_TRANSPARENT_lvtpzg.png";

  const socials = [
    { name: 'Instagram', icon: FiInstagram, url: '#' },
    { name: 'LinkedIn', icon: FiLinkedin, url: '#' },
    { name: 'YouTube', icon: FiYoutube, url: '#' }
  ];

  return (
    <footer className="bg-black py-16 md:py-20 border-t border-white/5 section-curve-up">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-12 mb-16 md:mb-20">
          <div className="flex items-center relative">
            <Link to="/" aria-label="Return to Living Media Homepage">
              <img 
                src={logoUrl} 
                alt="LIVING MEDIA" 
                loading="lazy"
                width="300"
                height="150"
                className="h-28 md:h-48 w-auto object-contain" 
              />
            </Link>
            <div className="absolute -top-4 -left-4 w-8 h-8 border-t border-l border-[#BEF264]/20 pointer-events-none" />
          </div>

          <div className="flex gap-6 md:gap-8">
            {socials.map(social => (
              <a 
                key={social.name} 
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-2 text-white/30 hover:text-[#BEF264] font-black uppercase tracking-[0.3em] text-[9px] md:text-[10px] transition-colors"
                aria-label={`Follow Living Media on ${social.name}`}
              >
                <SafeIcon icon={social.icon} className="w-4 h-4 stroke-[1.5px]" />
                <span className="hidden sm:inline">{social.name}</span>
              </a>
            ))}
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-8 text-[8px] md:text-[9px] font-black uppercase tracking-[0.3em] md:tracking-[0.4em] text-white/20 text-center md:text-left">
          <div className="flex items-center gap-4">
            <div className="w-4 h-[1px] bg-white/10 hidden md:block" />
            <div>© 2024 Living Media Group. All Rights Reserved.</div>
          </div>
          
          <div className="flex flex-wrap justify-center gap-6 md:gap-12">
            <Link to="/privacy" className="hover:text-white transition-colors" aria-label="Privacy Policy">Privacy</Link>
            <Link to="/terms" className="hover:text-white transition-colors" aria-label="Terms and Conditions">Terms</Link>
            <Link to="/cookie-policy" className="hover:text-white transition-colors" aria-label="Cookie Policy">Cookies</Link>
          </div>

          <div className="flex items-center gap-4">
            <div>EST. 2024 • GLOBAL</div>
            <div className="w-4 h-[1px] bg-white/10 hidden md:block" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;